<template>
    <div class="studentQuesMessage">
        <div class="content">
          
            <studentMessage :form="form"></studentMessage>
        </div>
        <!-- <div v-if="isShowBtn&&status!=3" class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="storeStudentCensusQuestion" :type="'btnGray'" name="保存" ></Button>
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div> -->
        <div  class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.push('/studyPlan/main')" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>

<script>
// import studentMessage from '@/components/consultant/ques/studentMessage.vue'
 import studentMessage from '@/components/consultant/ques/studentMessageDetail.vue'

import Button from '@/components/Button.vue'
export default {
    name: "parentMessage.vue",
    components: {
        Button,
        studentMessage
    },
    data() {
        return {
            status: 2,
            isShowBtn:true,
            form:{},
            resData:{}
            // form: {
            //     "name": "小欧",
            //     "sex": "1",
            //     "nation": "汉",
            //     "hometown": "山东省济宁市",
            //     "gaoYear": 2021,
            //     "province": "山东",
            //     "subject": ["物理", "化学", "生物"],
            //     "birth": "1995-03-09T16:00:00.000Z",
            //     "school": "第一中学",
            //     "class": "10班",
            //     "stressClass": 1,
            //     "classPosition": "班长",
            //     "inSchool": "1",
            //     "homeAddress": "山东省济宁市兖州区",
            //     "grade": "高二",
            //     "motherName": "母亲姓名",
            //     "motherWork": "母亲工作单位",
            //     "motherPost": "母亲职务",
            //     "motherEducation": "母亲学历",
            //     "motherPhone": "17800279716",
            //     "fatherName": "父亲",
            //     "fatherWork": "父亲工作单位",
            //     "fatherPost": "父亲职务",
            //     "fatherEducation": "父亲学历",
            //     "fatherPhone": "17800279718",
            //     "remarks": "家长基本信息备注",
            //     "learningGoal": "你给自己制定学习目标了吗，如何看待你的目标？：",
            //     "learningTime": "你能自己安排的时间有哪些？比如自习时间，会怎么分配时间？",
            //     "learningPlan": "你有制定学习计划的习惯吗，你会每天制定学习计划吗？",
            //     "learningTrouble": "在记忆和背诵知识点方面你是否存在困扰？具体描述一下你的困扰。",
            //     "learningPreview": "不预习",
            //     "learningClass": "不听课",
            //     "learningNote": "不做笔记",
            //     "learningReview": "不复习",
            //     "learningHomework": "从不",
            //     "learningArrange": "你会定期梳理所学知识，并进行总结和归纳吗，你认为自己的总结归纳能力如何？",
            //     "learningWrong": "你有整理错题的习惯吗？你是如何整理错题的？",
            //     "learningExam": "总紧张",
            //     "learningGrade": "波动大",
            //     "learningLookGoal": null,
            //     "learningTerm": null,
            //     "learningYuekao": null,
            //     "learningYearPeople": "1000",
            //     "learningGradeArr": [{
            //         "subject": "语文",
            //         "grade": "120",
            //         "rank": "300"
            //     }, {
            //         "subject": "数学",
            //         "grade": "120",
            //         "rank": "300"
            //     }, {
            //         "subject": "外语",
            //         "grade": "120",
            //         "rank": "300"
            //     }, {
            //         "subject": "物理",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "化学",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "生物",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "历史",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "政治",
            //         "grade": "90",
            //         "rank": "350"
            //     }, {
            //         "subject": "地理",
            //         "grade": "90",
            //         "rank": "350"
            //     }],
            //     "learningLikeRank": ['外语','政治','数学'],
            //     "learningGoodRank": ['外语','政治','数学'],
            //     "learningTeacherRank": ['外语','政治','数学'],
            //     "learningPower": "对我来说，学习过程中的动力有什么？",
            //     "learningFeel": "你喜欢学习吗，在学习过程中你的感受是怎样的？描述一下你的感受。",
            //     "learningHinder": "对我来说，学习过程中的阻碍有什么：",
            //     "learningMaxHinder": "其中最大的阻碍是：",
            //     "learningSolveHinder": "非常容易",
            //     "learningSolveLiyou": "我认为这种阻碍可以解决的程度是理由",
            //     "learningPotential": "很有潜力",
            //     "learningPotentialLiyou": "我认为自己的信息发展潜力如何：理由",
            //     "myClub": "我参加的社团",
            //     "myHobby": "我的兴趣爱好",
            //     "mySpecialty": "我的特长优势",
            //     "myShortcomings": "我的缺点不足",
            //     "myBestFriend": "我最好的朋友",
            //     "myLikeBook": "喜欢的书",
            //     "myLikeMovie": "喜欢的电影",
            //     "myLikeStar": "喜欢的明星",
            //     "myWish": "我的愿望",
            //     "myLikeCareer": "我向往的职业",
            //     "myLikeMajor": "我向往的专业",
            //     "myLikeUniversity": "我向往的大学：",
            //     "myAccomplishment": "最近做过让自己很有成就感的事：",
            //     "myUpset": "我最近的烦恼：",
            //     "myWantLife": "我未来想过的生活：",
            //     "isAwarded": "有",
            //     "awarded": [{
            //         "key": 1,
            //         "name": "奖励名称：",
            //         "year": 2016,
            //         "grade": "国家级"
            //     }, {
            //         "key": 1,
            //         "name": "奖励名称：",
            //         "year": 2017,
            //         "grade": "省级"
            //     }],
            //     "isWantOtherWay": "有",
            //     "otherWayList": ["强基计划", "综合评价", "高校专项计划"],
            //     "studyWill": "我认为科学、系统、完整的学习规划，对学习及个人发展有什么好处：",
            //     "otherHelp": "其他部分：希望获得哪些方面的帮助",
            //     "otherDescription": "其他部分： 其他说明"
            // },
        }
    },
    created() {
        this.detailStudentCensusQuestion();
    },
    methods: {
        checkTime(i) {
            if (i < 10) {
                i = '0' + i
            }
            return i
        },
        switchTimeFormat(time) {
            let date = new Date(time);
            return date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate())
        },

        detailStudentCensusQuestion() {
            this.$ajax.post(this.G_acapi+this.ports.student.message.detailStudentCensusQuestion,{
            },{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let data = res.data.data;
                    let censusQuestion = data.censusQuestion;
                    this.status = data.status;
                    if(censusQuestion) {
                        this.form = censusQuestion;
                        this.resData = data;
                    }else {
                        let form = this.form;
                        form.gaoYear = data.gaoYear;
                        form.name = data.name;
                        form.school = data.schoolName;
                        form.sex = data.sex;
                        this.form = form;
                    }
                }else{
                    this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                }
            })
        },
        storeStudentCensusQuestion() {
            // let params = this.resData;
            let data = this.form;
            // params.status = 3;
            // params.school = form.school;
            const params = {
                // name: data.name,
                // sex: data.sex,
                nation: data.nation,
                hometown: data.hometown,
                // gaoYear: data.gaoYear,
                // province: data.province,
                subject: data.subject,
                birth: data.birth,
                // school: data.school,
                class: data.class,
                stressClass: data.stressClass,
                classPosition: data.classPosition,
                inSchool: data.inSchool,
                homeAddress: data.homeAddress,
                grade: data.grade,
                status: 3,
                censusQuestion: data
            }
            this.$ajax.post(this.G_acapi+this.ports.student.message.storeStudentCensusQuestion,params,{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.isShowBtn = false;
                    this.$store.commit('getStudentStatus',3)
                    document.body.scrollIntoView();
                }else{
                    this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
.studentQuesMessage {
    .content {
        background-color: #fff;
        padding: 20px;
        min-height: 600px;
    }
}
</style>